module.exports = __webpack_public_path__ + "static/media/setting.dde26083.svg";